var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"project-tree",class:{'project-tree_full': _vm.activeZoom}},[_c('project-tree-header'),_c('project-tree-field')],1)}
var staticRenderFns = []

export { render, staticRenderFns }